import { useEffect, useMemo, useState } from "react";
import { TRUE } from "../../../Common/Constants";
import { useDatasources } from "../../../contexts/StoryblokContext/StoryblokContext";
import { QuotationApi } from "../../../apis/quotationApi";

export function usePaymentSummaryContent(quoteId: string) {
  const { featureSettings } = useDatasources();
  const quotationApi = useMemo(() => new QuotationApi(), []);

  const shouldDisplayGoToCampusCTAFlag = featureSettings.shouldDisplayCampusConnectCTAsOnTY === TRUE;
  const isStudentDetailsUpdateEnabledFlag = featureSettings.isStudentDetailsUpdateEnabled === TRUE;

  const [shouldDisplayGoToCampusCTA, setShouldDisplayGoToCampusCTA] = useState<boolean>(false);
  const [isStudentDetailsUpdateEnabled, setIsStudentDetailsUpdateEnabled] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsStudentDetailsUpdateEnabled(isStudentDetailsUpdateEnabledFlag);

    if (!shouldDisplayGoToCampusCTAFlag) {
      return;
    }

    setIsLoading(true);
    quotationApi
      .getMarketSettings(quoteId)
      .then((response) => {
        const isAutoBookingEnabled = response.autoBookingEnabled;
        if (!isAutoBookingEnabled) {
          setShouldDisplayGoToCampusCTA(false);
          console.log("Auto booking is not enabled for this market. Hiding Go To Campus CTA.");
        } else {
          setShouldDisplayGoToCampusCTA(true);
        }
      })
      .catch((err) => {
        setShouldDisplayGoToCampusCTA(false);
        console.error("Failed to fetch market settings", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [quoteId, shouldDisplayGoToCampusCTAFlag, isStudentDetailsUpdateEnabledFlag]);

  return { isStudentDetailsUpdateEnabled, shouldDisplayPostSubmissionCard: shouldDisplayGoToCampusCTA, isLoading };
}
